import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AboutDialogComponent } from '../about-dialog/about-dialog.component';
import * as moment from 'moment';
import { DataService } from 'src/app/core/services/data-service.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getMappedData, getWeatherStateIcon } from 'src/app/helperModules/chart.helpers';
import { ISerie, IndexFrontend } from 'src/app/shared/models/seriesInfo.interfaces';

declare let gtag: Function;

@Component({
  selector: 'app-side-layout',
  templateUrl: './side-layout.component.html',
  styleUrls: ['./side-layout.component.scss'],
})
export class SideLayoutComponent implements OnDestroy, OnInit {
  topCardImg: string = `assets/${environment.project}/top_card_icon.svg`;
  sideCardImg: string = `assets/${environment.project}/side_card_icon.svg`;
  title: string;

  allowSharing: boolean = environment.sharingAvailable;

  retrievedData: ISerie[] = [];

  temperature: number;
  temperatureSerie: ISerie;
  weatherState: number;
  maxTemp: number;
  minTemp: number;

  loading = true;

  href_logo: string;
  lastValuesDate: Date;
  projects: any[] = environment.stations || [];
  
  dataSub: Subscription;
  isModeled: boolean;

  constructor(private dataService: DataService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.dataService.getSiteSettings().subscribe((settings: any) => {
      this.href_logo = settings.url_logo;
      this.title = settings.page_name;
    });

    this.dataSub = this.dataService.windAtmosphereData$.subscribe((data) => {
      if (data.lastValues.length > 0) {
        this.isModeled = this.dataService.isWindAtmosphereModeled;
        let temperatures = []
        data.charts.yAxis.forEach(axis => axis.series.forEach(serie => {
          if (serie.indexFrontend === IndexFrontend.TemperatureChart) temperatures.push(serie);
        }))
        
        this.getData(data.lastValues
          .concat(...data.tables.filter(t => t.indexFrontend === IndexFrontend.WeatherStateTable))
          .concat(...temperatures)
        );
      }
    });
  }

  ngOnDestroy(): void { if (this.dataSub) this.dataSub.unsubscribe(); }

  getData(series: ISerie[]) {
    // Last value measure date
    this.assignData(series, 'lastValuesDate', 'date', s => s.indexFrontend === IndexFrontend.TemperatureLastValue);
    // Temperature last value
    this.assignData(series, 'temperature', 'lastValue', s => s.indexFrontend === IndexFrontend.TemperatureLastValue);

    
    let weatherState = series.find(s => s.indexFrontend === IndexFrontend.WeatherStateTable);
    if (weatherState) {
      this.weatherState = weatherState.chartValues
      .filter(v => v.date.getDay() === moment().day())                  // Filter by today
        .find(v => v.date.getHours() === moment().hours()).value        // Get the closest value to the hour
      }
      
      // Min and Max temperatures
      if (this.isModeled) {
        let tempSeries = series.find(s => s.indexFrontend === IndexFrontend.TemperatureChart);
        
        // Getting the chart values to get the min and max from this series
        let values = tempSeries.chartValues
        .filter(v => v.date.getDay() === moment().day())
        .map(value => value.value);
        
        this.minTemp = Math.min(...values);
        this.maxTemp = Math.max(...values);
      }
      else {
        this.assignData(series, 'minTemp', 'lastValue', s => s.indexFrontend === IndexFrontend.MinTemperatureLast24Hours);
        this.assignData(series, 'maxTemp', 'lastValue', s => s.indexFrontend === IndexFrontend.MaxTemperatureLast24Hours);
    }
    
    this.temperatureSerie = this.retrievedData.filter(s => s.indexFrontend === IndexFrontend.TemperatureLastValue)[0]
    this.loading = false;
  }

  assignData(series: ISerie[], target: string, source: string, predicate: (series: ISerie) => boolean) {
    let data = series.find(predicate);
    if (data) {
      this[target] = data[source];
  
      // Remove old cached entry (if any) and replace it
      const index = this.retrievedData.findIndex(predicate);
      if (index !== -1) {
        this.retrievedData.splice(index, 1, data);
      } else {
        this.retrievedData.push(data);
      }
    }
  }
  

  openAbout() {
    this.dialog.open(AboutDialogComponent, { panelClass: 'custom-dialog-container' });
  }

  getWeatherStateIcon = (stateValue: number) => getWeatherStateIcon(stateValue);

  onOpenedChanged(e) {
    gtag('event', 'shared_page', {
      eventCategory: 'share',
      eventAction: 'click',
      eventValue: e,
    });
  }

  isDataUnderTolerance() : boolean {
    for (let i = 0; i < this.retrievedData.length; i++) {
      const serie = this.retrievedData[i];
      const tolerance = moment().subtract(serie.communicationTolerance, 'seconds');
      return !moment(serie.date).isBefore(tolerance);
    }
  }
}
